import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export interface ErrorState extends Partial<AxiosError> {
  message: string | undefined;
  code: string | undefined;
  source: string | null;
  timestamp?: number;
  apiRoute?: string;
}

const initialState: ErrorState = {
  message: undefined,
  code: undefined,
  source: null,
  timestamp: undefined,
  apiRoute: undefined,
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<ErrorState>) => {
      state.message = action.payload.message;
      state.code = action.payload.code;
      state.source = action.payload.source || null; // Ensure source is set properly with a fallback to null
      state.timestamp = action.payload.timestamp || Date.now();
      state.apiRoute = action.payload.apiRoute;
    },
    clearError: (state) => {
      state.message = undefined;
      state.code = undefined;
      state.source = null;
      state.timestamp = undefined;
      state.apiRoute = undefined;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
